<template>
  <section>
    <p class="title is-2">Reporte de cuentas</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Cuentas</b-breadcrumb-item>
    </b-breadcrumb>
    <busqueda-cliente2 @seleccionado="onSeleccionado" />
    <mensaje-inicial
      class="mt-2"
      :titulo="'Elije un cliente para ver sus cuentas'"
      :subtitulo="'Aquí aparecerán las cuentas registradas'"
      v-if="cuentas.length < 1"
    />
    <div class="mt-2" v-if="cuentas.length > 0">
      <b-button @click="seleccionAccion">Abonar/liquidar</b-button>
      <b-button @click="historialAbonosx">Historial de abonos</b-button>

      <cartas-totales :totales="totalesGenerales" />
      <tabla-cuentas-apartados
        :datos="cuentas"
        :viene="1"
        @abonar="onAbonar"
        @liquidar="onLiquidar"
        @imprimir="onGenerarComprobante"
        @eliminar="onEliminar"
        @actualizarTabla="onActualizarTabla"
      />
    </div>
    <comprobante-compra
      :venta="this.cuentaSeleccionada"
      :tipo="'cuenta'"
      @impreso="onImpreso"
      v-if="mostrarComprobante"
    />
    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
<script>
import Swal from "sweetalert2";
import MensajeInicial from "../Extras/MensajeInicial";
import CartasTotales from "../Extras/CartasTotales";
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";
import TablaCuentasApartados from "./TablaCuentasApartados";
import ComprobanteCompra from "./ComprobanteCompra";
import BusquedaCliente2 from "../Clientes/BusquedaCliente2";

export default {
  name: "ReporteCuentas",
  components: {
    TablaCuentasApartados,
    MensajeInicial,
    CartasTotales,
    ComprobanteCompra,
    BusquedaCliente2,
  },

  data: () => ({
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
    cargando: false,
    cuentas: [],
    totalesGenerales: [],
    cuentaSeleccionada: null,
    mostrarComprobante: false,
    totalclientes: [],
    isExpanded: false,
    viene: 1,
    clientes: {},
    cliente: {},
    porPagar: 0,
    historialAbonos: [],
  }),

  computed: {
    filteredTotalClientes() {
      return this.totalclientes.filter((item) => item.porPagar > 0);
    },
  },
  mounted() {
    document.title = "Cuentas";
     this.obtenerCuentas();
  },

  methods: {
    onActualizarTabla() {
      this.obtenerCuentas();
    },
    onSeleccionado(cliente) {
      this.cliente = cliente;
      this.obtenerCuentas();
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    onImpreso(resultado) {
      this.mostrarComprobante = resultado;
    },
    onGenerarComprobante(cuenta) {
      this.cuentaSeleccionada = cuenta;
      this.mostrarComprobante = true;
    },
    onLiquidar(cuenta) {
      const usuario = localStorage.getItem("id");
      Swal.fire({
        title: `Selecciona el medio de pago`,
        input: "select",
        inputOptions: {
          efectivo: "Efectivo",
          nequi: "Nequi",
          transferencia: "Bancolombia",
          tarjeta: "Tarjeta",
        },
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Bancolombia",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value !== "") {
              resolve();
            } else {
              resolve("Debes seleccionar un medio de pago");
            }
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const medioDePago = result.value;

          Swal.fire({
            title: "¿Liquidar cuenta?",
            text: `El cliente debe pagar: $${parseInt(
              cuenta.porPagar
            ).toLocaleString("es-CO")}`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Liquidar",
          }).then((result) => {
            if (result.isConfirmed) {
              this.cargando = true;

              HttpService.registrar("vender.php", {
                accion: "liquidaTotalDeuda",
                total: cuenta.porPagar,
                id: cuenta.id,
                idUsuario: usuario,
                medioDePago: medioDePago,
                idCliente: this.cliente?.id || cuenta.idCliente || 0,
              }).then((resultado) => {
                if (resultado) {
                  this.cargando = false;
                  Swal.fire("Cuenta liquidada", "", "success");
                  this.obtenerCuentas();
                }
              });
            }
          });
        }
      });
    },
    onEliminar(datos) {
      console.log(datos);
      const fechaActual = new Date();
      const dia = String(fechaActual.getDate()).padStart(2, "0"); // Obtener día con dos dígitos
      const mes = String(fechaActual.getMonth() + 1).padStart(2, "0"); // Obtener mes con dos dígitos (mes empieza en 0)
      const año = fechaActual.getFullYear();
      const contraseñaCorrecta = `${dia}${mes}${año}`; // Contraseña en formato DDMMYYYY

      Swal.fire({
        title: "¿Está seguro?",
        text: `Esta acción no se puede deshacer, se eliminará la cuenta de ${datos.nombreCliente}. Se creará un registro del que eliminó esta cuenta, junto con la fecha y hora.`,
        icon: "warning",
        input: "password", // Solicita la contraseña
        inputPlaceholder: "Ingrese la contraseña :)",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        preConfirm: (password) => {
          if (password !== contraseñaCorrecta) {
            Swal.showValidationMessage("Contraseña incorrecta");
            return false;
          }
          return true;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargando = true; // Indicar que se está realizando una operación
          // Aquí podrías agregar la lógica para guardar el registro de eliminación (con fecha, hora y quién eliminó)
          const fechaHoraEliminacion = `${dia}/${mes}/${año} ${fechaActual.getHours()}:${fechaActual.getMinutes()}:${fechaActual.getSeconds()}`;

          // Simulación de registro de eliminación (puedes ajustarlo según tu sistema)
          console.log(
            `Registro de eliminación: Cliente: ${datos.nombreCliente}, Eliminado por: usuarioActual, Fecha y hora: ${fechaHoraEliminacion}`
          );

          HttpService.eliminar("vender.php", {
            accion: "eliminarCuenta",
            id: datos.id,
            registroEliminacion: {
              // Información adicional del registro
              usuario: "usuarioActual", // Aquí iría el nombre o ID del usuario que eliminó
              fechaHora: fechaHoraEliminacion,
            },
          }).then((resultado) => {
            this.cargando = false; // Finalizar la indicación de carga
            if (!resultado) {
              this.$buefy.toast.open("Error al eliminar");
              return;
            }
            this.$buefy.toast.open("Cuenta eliminada correctamente");
            this.obtenerCuentas();
          });
        }
      });
    },
    onAbonar(cuenta) {
      const usuario = localStorage.getItem("id");

      Swal.fire({
        title: `Selecciona el medio de pago`,
        input: "select",
        inputOptions: {
          efectivo: "Efectivo",
          nequi: "Nequi",
          transferencia: "Bancolombia",
          tarjeta: "Tarjeta",
        },
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Seleccionar",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value !== "") {
              resolve();
            } else {
              resolve("Debes seleccionar un medio de pago");
            }
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const medioDePago = result.value;

          Swal.fire({
            title: `Escribe el total del abono. Restan: $${parseInt(
              cuenta.porPagar
            ).toLocaleString("es-CO")}`,
            input: "number",
            inputAttributes: {
              placeholder: "Abono",
              min: 1,
              max: cuenta.porPagar,
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Abonar",
            preConfirm: (value) => {
              return new Promise((resolve) => {
                if (value !== "" && value >= 1) {
                  resolve(parseFloat(value));
                } else {
                  resolve("Debes ingresar un valor válido");
                }
              });
            },
          }).then((result) => {
            if (result.isConfirmed) {
              const abono = result.value;

              this.cargando = true;

              HttpService.registrar("vender.php", {
                accion: "abonarCuenta",
                total: abono,
                id: cuenta.id,
                idUsuario: usuario,
                medioDePago: medioDePago,
                idCliente: this.cliente?.id || cuenta.idCliente || 0,
              }).then((resultado) => {
                if (resultado) {
                  this.cargando = false;
                  Swal.fire("Abono registrado", "", "success");
                  this.obtenerCuentas();
                }
              });
            }
          });
        }
      });
    },
    obtenerCuentas() {
      this.cargando = true;
      let payload = {
        filtros: this.filtros,
        accion: "obtener_cuentas",
        cliente: this.cliente.id,
      };
      HttpService.obtenerConConsultas("vender.php", payload).then(
        (resultado) => {
          this.cuentas = resultado.cuentas;
          this.totalclientes = resultado.clientes;
          this.porPagar = resultado.totalPorPagar;
          this.totalesGenerales = [
            {
              nombre: "# Cuentas",
              total: this.cuentas.length,
              icono: "wallet",
              clase: "has-text-primary",
            },
            {
              nombre: "Pagado",
              total:
                "$" + parseInt(resultado.totalPagos).toLocaleString("es-CO"),
              icono: "check-circle",
              clase: "has-text-success",
            },
            {
              nombre: "Por pagar",
              total:
                "$" + parseInt(resultado.totalPorPagar).toLocaleString("es-CO"),
              icono: "alert",
              clase: "has-text-danger",
            },

            {
              nombre: "# Productos",
              total: parseInt(Utiles.calcularProductosVendidos(this.cuentas)),
              icono: "package-variant",
              clase: "has-text-warning",
            },
          ];
          this.cargando = false;
        }
      );
    },
    historialAbonosx() {
      // Verificar si el cliente está vacío
      if (!this.cliente || !this.cliente.id) {
        // Si está vacío, mostrar una alerta y salir de la función
        Swal.fire({
          title: "Error",
          text: "Debe seleccionar un cliente para esta acción.",
          icon: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      // Si el cliente está definido, proceder con la solicitud HTTP
      this.cargando = true;
      let payload = {
        accion: "obtenerHistorialAbonos",
        cliente: this.cliente.id,
      };

      HttpService.obtenerConConsultas("vender.php", payload).then(
        (historial) => {
          this.historialAbonos = historial;
          this.mostrarHistorialAbonos();
          this.cargando = false;
        }
      );
    },

    mostrarHistorialAbonos() {
      const datos = this.historialAbonos; // Obtener los datos de historialAbonos

      // Función para formatear la fecha
      const formatearFecha = (fecha) => {
        const opciones = { year: "numeric", month: "long", day: "numeric" };
        return new Date(fecha).toLocaleDateString("es-ES", opciones); // Formato "día mes año"
      };

      // Función para mostrar los métodos de pago con nombres personalizados
      const obtenerMetodoPago = (dato) => {
        let pagos = [];

        if (dato.efectivo > 0)
          pagos.push(
            `Efectivo: $${parseInt(dato.efectivo).toLocaleString("es-CO")}`
          );
        if (dato.nequi > 0)
          pagos.push(
            `Nequi  $${parseInt(dato.nequi).toLocaleString("es-CO")}`
          );
        if (dato.transferencia> 0)
          pagos.push(
            `Bancolombia $${parseInt(dato.transferencia).toLocaleString("es-CO")}`
          );
        if (dato.tarjeta > 0)
          pagos.push(
            `Tarjeta: $${parseInt(dato.tarjeta).toLocaleString("es-CO")}`
          );
      
        return pagos.join("<br>"); // Se agregan los métodos de pago separados por salto de línea
      };

      let contenidoHTML = `
        <div style="max-height: 600px; overflow-y: auto; text-align: left;">
            <table style="width: 100%; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th style="padding: 10px; border-bottom: 2px solid #ddd;">Fecha</th>
                        <th style="padding: 10px; border-bottom: 2px solid #ddd;">Método de Pago</th>
                        <th style="padding: 10px; border-bottom: 2px solid #ddd;">Atendido por</th>
                    </tr>
                </thead>
                <tbody>
                    ${datos
                      .map(
                        (dato) => `
                        <tr>
                            <td style="padding: 10px; border-bottom: 1px solid #eee;">${formatearFecha(
                              dato.fecha
                            )}</td>
                            <td style="padding: 10px; border-bottom: 1px solid #eee;">
                                ${obtenerMetodoPago(dato)}
                            </td>
                            <td style="padding: 10px; border-bottom: 1px solid #eee;">${
                              dato.nombre_usuario
                            }</td>
                            
                             }</td>
                        </tr>
                    `
                      )
                      .join("")}
                </tbody>
            </table>
        </div>
    `;

      // Mostrar el modal SweetAlert2
      Swal.fire({
        title: "<h2>Historial de Abonos</h2>",
        html: contenidoHTML,
        width: "80%", // Ajustar el ancho del modal
        customClass: {
          popup: "swal-wide-popup", // Clase personalizada para más control si es necesario
        },
        showCloseButton: true,
        confirmButtonText: "Cerrar",
      });
    },

    seleccionAccion() {
      // Verificar si el cliente está vacío
      if (!this.cliente || !this.cliente.id) {
        // Si está vacío, mostrar una alerta y salir de la función
        Swal.fire({
          title: "Error",
          text: "Debe seleccionar un cliente para realizar esta acción.",
          icon: "warning",
          confirmButtonText: "Aceptar",
        });
        return; // Detener la ejecución de la función
      }

      // Si el cliente está definido, continuar con la selección de acción
      const cuenta = {
        idCliente: this.cliente.id,
        porPagar: this.porPagar,
        id: "",
      };

      Swal.fire({
        title: "¿Qué acción deseas realizar?",
        text: "Selecciona una opción",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: '<i class="icon-check-circle"></i> Liquidar',
        cancelButtonText: '<i class="icon-wallet"></i> Abonar',
        customClass: {
          confirmButton: "btn-liquidar",
          cancelButton: "btn-abonar",
        },
        buttonsStyling: false, // Importante para usar clases personalizadas
      }).then((result) => {
        if (result.isConfirmed) {
          this.onLiquidar(cuenta);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.onAbonar(cuenta);
        }
      });
    },
  },
};
</script>

<style>
.expand-button {
  cursor: pointer;
  padding: 4px;
  background-color: rgb(48, 54, 66);
  text-align: center;
  width: 20px;
  margin-bottom: 8px;
}

.expand-button span {
  font-weight: bold;
}

.expanded .custom-table {
  display: table;
}

.expanded .expand-button span {
  transform: rotate(-90deg);
}

/* Botón para la acción Liquidar */
.btn-liquidar {
  background-color: #28a745; /* Verde */
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 10px; /* Espacio entre los botones */
}

.btn-liquidar:hover {
  background-color: #218838; /* Verde más oscuro */
}

/* Botón para la acción Abonar */
.btn-abonar {
  background-color: #007bff; /* Azul */
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px; /* Espacio entre los botones */
}

.btn-abonar:hover {
  background-color: #0056b3; /* Azul más oscuro */
}
</style>